import { render, staticRenderFns } from "./add-result-dialog.vue?vue&type=template&id=22a6437c&scoped=true"
import script from "./add-result-dialog.vue?vue&type=script&lang=js"
export * from "./add-result-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-result-dialog.vue?vue&type=style&index=0&id=22a6437c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6437c",
  null
  
)

export default component.exports